module.exports = __webpack_public_path__ + "static/fabric-breadcrumb-collapsable-e7dcf8f0e2153ea9906150ebe94cced2.png";